import {batch} from 'react-redux';
import {getCurrentDeckId} from '../selectors';
import {DECK_RECEIVE, SET_SEARCH_PARAMS} from '../actions/ActionTypes';

export const deckReceive = deck => (dispatch, getState) => {
  const state = getState();
  const currentDeckId = getCurrentDeckId(state);
  const isCurrentDeck = deck.id === currentDeckId;

  return batch(() => {
    dispatch({
      type: DECK_RECEIVE,
      payload: deck
    });

    // Dispatch an action to ensure that slideIndex and currentSlideId are set
    // correctly; if the deck's slide_order array has changed then those bits
    // of state will need updating.
    if (isCurrentDeck) {
      dispatch({
        type: SET_SEARCH_PARAMS,
        payload: {
          slideOrder: deck.slide_order,
        }
      });
    }
  });
};
